<template lang="pug">
  div.image-wrapper
      img.image(:src="getImgUrl()")
</template>

<script>
    export default {
        methods: {
            getImgUrl() {
                const randomNumber = Math.floor(Math.random() * 10 + 1);
                return '/imgs/games/secrets-of-cicero/' + randomNumber + '.jpg';
            },
        },
    };
</script>

<style lang="scss" scoped>
    .image-wrapper {
        display: flex;
        width: 100%;
        justify-content: flex-end;
    }
    .image {
        width: 550px;
        @include media($xl) {
            width: 680px;
        }
    }
</style>
